import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../assets/icon.png';
import './navbar.css';
import { useAuth } from '../../context/AuthContext';

const Menu = () => (
  <>
    <p><a href="#home">Explore</a></p>
    <p><a href="#fTaasa">Purpose</a></p>
    <p><a href="#features">Features</a></p>
    <p><a href="#uses">Early Access</a></p>
    <p><a href="#blog">Publications</a></p>
  </>
);

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className='taasa__navbar'>
      <div className='taasa__navbar-links'>
        <div className='taasa__navbar-links_logo'>
          <img src={logo} alt='taasa logo' />
        </div>
        <div className='taasa__navbar-links_container'>
          <Menu />
        </div>
      </div>
      <div className='taasa__navbar-sign'>
        {isAuthenticated ? (
          <>
            <p className="text-white mr-4">Welcome, {user?.fullName || user?.email}</p>
            <Link to="/dashboard">
              <button type="button" className="mr-2">Dashboard</button>
            </Link>
            <button onClick={handleLogout} type="button">Log Out</button>
          </>
        ) : (
          <>
            <Link to="/register">
              <p type="button">Signup</p>
            </Link>
            <Link to="/login">
              <button type="button">Log In</button>
            </Link>
          </>
        )}
      </div>
      <div className="taasa__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />
        }
        {toggleMenu && (
          <div className="taasa__navbar-menu_container scale-up-center">
            <div className="taasa__navbar-menu_container_links">
              <Menu />
              <div className='taasa__navbar-menu_container-links-sign'>
                {isAuthenticated ? (
                  <>
                    <p className="text-white">Welcome, {user?.fullName || user?.email}</p>
                    <Link to="/dashboard">
                      <button type="button">Dashboard</button>
                    </Link>
                    <button onClick={handleLogout} type="button">Log Out</button>
                  </>
                ) : (
                  <>
                    <Link to="/register">
                      <p type="button">Signup</p>
                    </Link>
                    <Link to="/login">
                      <button type="button">Log In</button>
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;